// @mui
import { styled } from '@mui/material/styles';
import { Card, Container } from '@mui/material';
// hooks
// components
// sections
import AddMemberRoleForm from './AddMemberRoleForm';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  // minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  // backgroundColor: 'black',
  // padding: theme.spacing(12, 0),
  padding: '0px',
}));

// ----------------------------------------------------------------------

export default function AddMemberRole({ closePopup, handleAddSuccess }) {
  return (
    <Container>
      <ContentStyle>
        <AddMemberRoleForm closePopup={closePopup} handleAddSuccess={handleAddSuccess} />
      </ContentStyle>
    </Container>
  );
}
